import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/shared/Logo";
import { Button } from "@/components/ui/button";

export function Landing() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8 text-center">
        <Logo />
        <div className="space-y-4">
          <p className="text-lg text-muted-foreground">
            {t("register.subtitle")}
          </p>
        </div>
        <div className="space-y-3">
          <Button
            onClick={() => navigate("/register")}
            className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90"
            size="lg"
          >
            {t("register.createAccount")}
          </Button>
          <Button
            onClick={() => navigate("/login")}
            variant="outline"
            className="w-full"
            size="lg"
          >
            {t("login.signIn")}
          </Button>
        </div>
      </div>
    </div>
  );
}
